module.exports = __webpack_public_path__ + "img/ladder.6cd22c8d.svg";